import React from 'react';
import PropTypes from 'prop-types';
import css from './DropdownOptionLabel.css';

const DropdownOptionLabel = ({ value, label, isDivider }) => {
    if (isDivider) return <hr className={css.divider} />;
    return (
        <span className={css.dropdownOption}>
            <code className={css.dropdownKey}>{value}</code>
            <span>{label}</span>
        </span>
    );
};

DropdownOptionLabel.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isDivider: PropTypes.bool,
};

export default DropdownOptionLabel;
